import api from '@/api';

/**
 * @class ClientActionAssign
 */
class ClientActionAssign {
  /**
   *
   *
   * @static
   * @returns
   * @memberof ActionAssign
   */
  static get(teamId = null) {
    return api.get('/actions/client/assign', { params: { teamId } });
  }

  /**
   * @static
   * @param {*} { reviewerId, internalDueDate, clientActionIds }
   * @returns
   * @memberof ClientActionAssign
   */
  static assign({
    clientActionIds, teamId, userId = null, internalDueDate = null, internalDueDateWeek = null,
  }) {
    const params = {
      clientActionIds,
      teamId,
    };

    if (userId) {
      params.userId = userId;
    }

    if (internalDueDate) {
      params.internalDueDate = internalDueDate;
    }

    if (internalDueDateWeek) {
      params.internalDueDateWeek = internalDueDateWeek;
    }

    return api.post('/actions/client/assign', params);
  }

  /**
   *
   *
   * @static
   * @returns
   * @memberof ClientActionAssign
   */
  static async getFormattedOptions(teamId = null) {
    try {
      const { data } = await ClientActionAssign.get(teamId);
      return ClientActionAssign.formatTeams(data.data);
    } catch (e) {
      return [];
    }
  }

  /**
   *
   *
   * @static
   * @param {*} [teams={}]
   * @returns
   * @memberof ClientActionAssign
   */
  static formatTeams(teams = {}) {
    const options = [];

    const allTeams = [];
    const labels = {};
    const teamsWithUsers = [];

    Object.entries(teams).forEach(([key, team]) => {
      allTeams.push({
        label: team.name,
        teamId: team.teamId,
        parentTeamId: team.parentTeamId,
        team: team.teamId,
      });

      const teamUsers = [];

      let { name  } = team;
      if (labels[team.parentTeamId]) {
        name = `${labels[team.parentTeamId]} > ${name}`;
      }

      labels[team.teamId] = name;

      team.label = name;
      team.team.client_users.forEach((user, key) => {

        let label = `${user.user.firstName} ${user.user.lastName}`;
        if (!user.user.active || !user.activeForClient) {
          label = `${label} (Inactive)`;
        }

        teamUsers.push({
          label,
          userId: user.userId,
          teamId: team.teamId,
          user: user.userId,
          $isDisabled: user.active === 0,
        });
      });

      teamsWithUsers.push({
        team: team.label,
        items: teamUsers,
      });
    });

    // All teams
    options.push({
      team: 'Teams',
      items: allTeams,
    });

    // Grouped Teams with users underneath
    teamsWithUsers.forEach((team) => {
      options.push(team);
    });


    return options;
  }
}

export default ClientActionAssign;
